import { useContext, useEffect, useState } from "react";
import { BackgroundTask } from "./BackgroundTasks";
import { BackgroundTasksContext } from "./BackgroundTasksProvider";

export function useBackgroundTaskManager() {
  const backgroundTaskManager = useContext(BackgroundTasksContext);
  if (!backgroundTaskManager) {
    throw new Error(
      "useBackgroundTaskManager must be used within a BackgroundTasksProvider"
    );
  }
  return backgroundTaskManager;
}

export function useBackgroundTasks() {
  const backgroundTaskManager = useBackgroundTaskManager();

  const [tasks, setTasks] = useState<BackgroundTask[]>(
    Array.from(backgroundTaskManager.tasks)
  );

  useEffect(() => {
    function listener() {
      setTasks([...backgroundTaskManager.tasks]);
    }

    const offTaskStateChanged = backgroundTaskManager.on(
      "taskStateChanged",
      listener
    );
    const offTaskAdded = backgroundTaskManager.on("taskAdded", listener);
    const offTaskRemoved = backgroundTaskManager.on("taskRemoved", listener);
    return () => {
      offTaskStateChanged();
      offTaskAdded();
      offTaskRemoved();
    };
  }, [backgroundTaskManager]);

  return tasks;
}
